module.exports = __webpack_public_path__ + "img/pearls.be6a9245.webp";